module.exports = __webpack_public_path__ + "img/accessibility.a445370f.svg";